// extracted by mini-css-extract-plugin
export var copyableItem = "_46-0";
export var underlined = "_46-1";